var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-id",class:{'dark': _vm.dark}},[_c('span',[_vm._v(_vm._s(_vm.$store.getters.translate('event')))]),_c('span',[_vm._v(_vm._s(_vm.eventId))])])
}
var staticRenderFns = []

export { render, staticRenderFns }